import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
